/**
 * Remove markdown formatting from the provided text.
 */
export function removeMarkdown(text: string) {
  // Currently, only bold formatting is removed.
  // Full removal would involve heavy libraries (e.g. strip-markdown + remark).
  return text.replace(/(\*\*|__)(.*?)\1/g, '$2')
}
